export enum DialogType {
  DELETE_CONFIRMATION_DIALOG = "DELETE_CONFIRMATION_DIALOG",
  LITIGE_CONFIRMATION_DIALOG = "LITIGE_CONFIRMATION_DIALOG",
  CANCELED_RETURN_CONFIRMATION_DIALOG = "CANCELED_RETURN_CONFIRMATION_DIALOG",
  DELIVERY_CONFIRMATION_BY_PJ_DIALOG = "DELIVERY_CONFIRMATION_BY_PJ_DIALOG",
  DELIVERY_CONFIRMATION_DIALOG = "DELIVERY_CONFIRMATION_DIALOG",
  PICKUP_CONFIRMATION_DIALOG = "PICKUP_CONFIRMATION_DIALOG",
  REQUEST_RETURN_CREATE_DIALOG = "REQUEST_RETURN_CREATE_DIALOG",
}
